import React from 'react';
import redpaperplane from '../assets/red-paperplane.png';
import whitepaperplane from '../assets/Group 3.png';
import { useNavigate } from 'react-router-dom';

const Hero = () => {
  // const handleScrollToThinkFinance = () => {
  //   // Find the ThinkFinance section by ID
  //   const thinkFinanceSection = document.getElementById('thinkfinance');
    
  //   if (thinkFinanceSection) {
  //     thinkFinanceSection.scrollIntoView({ behavior: 'smooth' });
  //   }
  // };
  const navigate = useNavigate();

  const handleNavigate = (path) => {
    navigate(path);
    window.scrollTo(0, 0);
  }

  return (
    <section className="hero">
      <div className="container hero-container">
        <div className="hero-content">
          <h1>Data Analytics to Accelerate Your Business Growth</h1>
          <h2>
            <strong>Are you using data analytics?</strong>
          </h2>
          <p>
            If not, you might be sitting on a mine of raw data with the potential to transform your business. 
            Discover the hidden value in your data and accelerate your business growth with our cost-effective 
            data analytics solutions. Let us help you harness your data mine, leveraging it into valuable 
            insights that drive smart decisions for a competitive edge.
          </p>
          <button 
            className="cta-button"
            onClick={() => handleNavigate('/contactus')}
          >
            Get Started
          </button>
        </div>
        
        <div className="hero-images">
          <div className="hero-image">
            <img src={redpaperplane} alt="paperplane"/>
          </div>
          <div className="hero-image-2">
            <img src={whitepaperplane} alt="paperplane2"/>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;